import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { CustomLayout } from "../components";
import Menu from "../pages/VrLearning/templates/LearningMenu";
import { getAllGroups, getAllProjectsByEnterprise, getAllResponsesFormProject } from "../redux/VRL/thunks";

const LayoutVrLearning = () => {
    const { typeAdmin } = useSelector((state) => state.auth);
    const dispatch = useDispatch()
    console.log("uset type:", typeAdmin)

    useEffect(() => {
        const getApiInfo = async () => {
            const proyects = await dispatch(getAllProjectsByEnterprise())
            if (proyects) {
                dispatch(getAllResponsesFormProject(proyects[0]._id))
                dispatch(getAllGroups(proyects[0]._id))
            }
        }
        getApiInfo()
    }, [dispatch])

    if (typeAdmin === 'VRL') {
        return (
            <CustomLayout>
                <Menu />
                <Outlet />
            </CustomLayout>
        )
    }
    else {
        return <Navigate to={"/auth/"}> </Navigate>
    }
    // return typeAdmin === 'VRL' ? : 
    // return (
    //     <CustomLayout>
    //         <TrainingMenu />
    //         <Outlet />
    //     </CustomLayout>
    // );
};

export default LayoutVrLearning;
